exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-3f5b9eb4] {\n    display: inline-block;\n    padding: .25em .4em;\n}\n", ""]);

// exports
